<div class="flex flex-col gap-4">
    @if (isLoading) {
        <div
            class="flex min-h-[240px] items-center justify-center rounded-3xl border border-slate-200 bg-white"
        >
            <app-loading-ring></app-loading-ring>
        </div>
    }
    @if (!isLoading) {
        @if (hasMixedInputTypes && !itemId && !activeInputType) {
            <div class="flex flex-col gap-4">
                <div
                    class="rounded-[28px] border border-slate-200 bg-gradient-to-br from-slate-900 via-slate-800 to-teal-800 p-6 text-white"
                >
                    <p
                        class="text-xs font-semibold uppercase tracking-[0.3em] text-white/70"
                    >
                        {{ 'translate_select_evaluation_mode' | translate }}
                    </p>
                    <h3 class="mt-2 text-2xl font-bold">
                        {{
                            'translate_choose_evaluation_definition' | translate
                        }}
                    </h3>
                    <p class="mt-2 max-w-3xl text-sm leading-7 text-white/80">
                        {{ 'translate_rubric_workspace_hint' | translate }}
                    </p>
                </div>
                <div class="grid gap-4 md:grid-cols-2">
                    @for (evaluation of evaluations; track evaluation) {
                        <button
                            type="button"
                            (click)="selectEvaluation(evaluation)"
                            class="group rounded-[26px] border border-slate-200 bg-white p-5 text-start transition hover:-translate-y-1 hover:border-teal-300 hover:shadow-[0_24px_60px_-32px_rgba(15,118,110,0.45)]"
                        >
                            <div class="flex items-start justify-between gap-4">
                                <div class="flex flex-col gap-3">
                                    <span
                                        class="inline-flex rounded-full px-3 py-1 text-xs font-semibold"
                                        [ngClass]="
                                            evaluation.inputType === 'rubric'
                                                ? 'bg-teal-100 text-teal-700'
                                                : 'bg-slate-100 text-slate-700'
                                        "
                                    >
                                        {{
                                            (evaluation.inputType === 'rubric'
                                                ? 'translate_rubric_evaluation'
                                                : 'translate_standard_evaluation'
                                            ) | translate
                                        }}
                                    </span>
                                    <div>
                                        <h4
                                            class="text-lg font-bold text-slate-900 transition group-hover:text-teal-700"
                                        >
                                            {{ evaluation.name }}
                                        </h4>
                                        <p
                                            class="mt-2 text-sm leading-7 text-slate-500"
                                        >
                                            {{
                                                evaluation.description ||
                                                    evaluation.name
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div
                                    class="flex h-11 w-11 items-center justify-center rounded-2xl"
                                    [ngClass]="
                                        evaluation.inputType === 'rubric'
                                            ? 'bg-teal-50 text-teal-700'
                                            : 'bg-slate-100 text-slate-700'
                                    "
                                >
                                    <i
                                        class="fa-light"
                                        [ngClass]="
                                            evaluation.inputType === 'rubric'
                                                ? 'fa-table-cells-large'
                                                : 'fa-list-check'
                                        "
                                    ></i>
                                </div>
                            </div>
                        </button>
                    }
                </div>
            </div>
        }
        @if (hasMixedInputTypes && !itemId && activeInputType) {
            <div class="flex justify-end">
                <button
                    type="button"
                    (click)="showSelectionScreen()"
                    class="btn-outline-secondary btn flex items-center gap-2"
                >
                    <i class="fa-light fa-arrow-rotate-left"></i>
                    <span>{{
                        'translate_change_evaluation_type' | translate
                    }}</span>
                </button>
            </div>
        }
        @if (activeInputType === 'standard') {
            <app-evaluation-instance-detail
                [entityId]="entityId"
                [savedEntityId]="savedEntityId"
                [initialEvaluationId]="initialEvaluationId"
                [itemId]="itemId"
                [type]="type"
                [mode]="mode"
                [customAction]="customAction"
                [useGroupedProjectStandards]="useGroupedProjectStandards"
                [hideNotes]="hideNotes"
                (update)="update.emit($event)"
            ></app-evaluation-instance-detail>
        }
        @if (activeInputType === 'rubric') {
            <app-rubric-evaluation-instance-detail
                [entityId]="entityId"
                [savedEntityId]="savedEntityId"
                [initialEvaluationId]="initialEvaluationId"
                [itemId]="itemId"
                [type]="type"
                [mode]="mode"
                [customAction]="customAction"
                [hideNotes]="hideNotes"
                (update)="update.emit($event)"
            ></app-rubric-evaluation-instance-detail>
        }
    }
</div>
